export default `
<div class="course-section">
  <h2 class="course-section-title"  ng-if="!$ctrl.isFirstSection" ng-bind="$ctrl.section.title"></h2>
  <article class="course-content" ng-bind-html="$ctrl.section.content | uMarkdown | trustAsHtml"></article>
</div>
`;
